import { Card, Empty, Flex, Typography } from 'antd'
import { useTranslation } from 'react-i18next'

import { ApiPendingBadge } from 'src/features/organization/components'

const { Text } = Typography

type Props = {
  messageKey: string
}

export const TabPlaceholder = ({ messageKey }: Props) => {
  const { t } = useTranslation()

  return (
    <Card>
      <Empty
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        description={
          <Flex vertical align="center" gap={6}>
            <ApiPendingBadge />
            <Text type="secondary" style={{ fontSize: 12 }}>
              {t(messageKey)}
            </Text>
          </Flex>
        }
      />
    </Card>
  )
}
